import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import type { NewPasswordLocationState } from 'pages';

export const useExpiredPassword = <T>() => {
  const navigate = useNavigate();
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const state: T | undefined = location.state;

  return useMemo(
    () => ({
      async onExpiredPassword(email: string) {
        await navigate('/new-password/', { state: { ...state, email } satisfies NewPasswordLocationState });
      },
    }),
    [navigate, state],
  );
};
